import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Alert,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem  
} from '@mui/material';
import Header from "../components/Header";
import Footer from "../components/Footer";
import FooterPlayer from "../components/FooterPlayer"; // ✅ new import


const Login = () => {
  const navigate = useNavigate();

  // Get redirect parameter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get('redirect') || '/hub';

  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
 const [cartQty, setCartQty] = useState(0);
  const [user, setUser] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

      useEffect(() => {
        try {
          const savedCart = localStorage.getItem('cart');
          if (savedCart) {
            const cart = JSON.parse(savedCart);
            if (Array.isArray(cart)) {
              setCartQty(cart.length);
            } else {
              setCartQty(0);
            }
          } else {
            setCartQty(0);
          }
        } catch (e) {
          console.error('Failed to parse cart', e);
          setCartQty(0);
        }
      }, []);
    
    
  
    const navLinks = [
      { text: "TOUR", link: "/#upcoming" },
      { text: "STREAM", link: "/#stream" },
      { text: "RELEASES", link: "/#releases" },
      { text: "SHOP", link: "/#boutique", external: true },
      { text: "ABOUT", link: "/#about" },
    ];
  
       const socialLinks = [
      { text: 'Facebook', link: 'https://www.facebook.com/example' },
      { text: 'Twitter', link: 'https://twitter.com/example' },
      { text: 'Instagram', link: 'https://www.instagram.com/example' },
      { text: 'LinkedIn', link: 'https://www.linkedin.com/company/example' },    
  ];
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/users/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('user', JSON.stringify(data.user));
        window.location.href = redirectUrl;
      } else {
        setError(data.message || 'Invalid credentials');
      }
    } catch (err) {
      setError('An error occurred during login');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Handle guest checkout
  const handleGuestCheckout = async () => {
    setLoading(true);
    try {
      const res = await fetch('/users/guest-session', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await res.json();

      if (data.success) {
        localStorage.setItem('user', JSON.stringify({ guest: true, ...data.user }));
        navigate('/shopping-cart');
      } else {
        setError('Unable to continue as guest.');
        setLoading(false);
      }
    } catch (err) {
      console.error('Guest session error:', err);
      setError('Network error creating guest session. Please try signing in or registering.');
      setLoading(false);
    }
  };

  // Normal login form
  return (
    <>
    <Header
  menuItems={navLinks}
  logo="/images/mihu-logo-trans.png" 
  cartQty={cartQty}
/>
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        backgroundImage: 'url(/images/rainbow_bg.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Sign In
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="username"
              type="email"
              value={formData.username}
              onChange={handleChange}
              required
              margin="normal"
            />

            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
              margin="normal"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 3 }}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>

            {/* {redirectUrl === '/shopping-cart' && (
              <>
                <Typography 
                  align="center" 
                  sx={{ mt: 2, mb: 1, color: 'text.secondary' }}
                >
                  OR
                </Typography>
                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  onClick={handleGuestCheckout}
                  disabled={loading}
                  sx={{ mt: 1 }}
                >
                  Continue as Guest
                </Button>
              </>
            )} */}

            <Button
              fullWidth
              variant="text"
              onClick={() => {
                const registerUrl =
                  redirectUrl !== '/hub'
                    ? `/register?redirect=${encodeURIComponent(redirectUrl)}`
                    : '/register';
                window.location.href = registerUrl;
              }}
              sx={{ mt: 1 }}
            >
              Don't have an account? Register
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
    <FooterPlayer />
    </>
  );
};

export default Login;